export enum Status {
    Idle = 'idle',
    Pending = 'pending',    
    Finished = 'finished',
}

export enum EmailValidation {
    Valid = 'valid',
    Invalid = 'invalid',    
    Exist = 'exist',
}